// angular.module('HeroPRO').directive('searchFilterGenerator',

/* @ngInject */
export default function SearchFilterGeneratorDirective($compile, $rootScope, $location) {
    return {
        restrict: 'E',
        scope: {
            currentFilter: '=',
            last: '=',
        },
        link(scope, element) {
            scope.processFilter = function () {
                $rootScope.$broadcast('searchFiltersGenerator.processFilter');
            };

            scope.getFilterURLValues = function (currentFilter) {
                const resultValues = [];

                /* global atob */
                const filterQueryString = $location.search().filters ? atob($location.search().filters) : undefined;
                let filterPartsFromQueryString = null;

                if (filterQueryString !== undefined && filterQueryString !== '') {
                    filterPartsFromQueryString = filterQueryString.split('|');
                }

                if (filterPartsFromQueryString && filterPartsFromQueryString.length > 0) {
                    for (const filterParts in filterPartsFromQueryString) {
                        const parts = filterPartsFromQueryString[filterParts].split('_');
                        const productAttributeNameId = parts[0];
                        const values = parts[1] ? parts[1].split('~') : null;

                        if (currentFilter.Deprecated_ProductAttributeNameId === parseInt(productAttributeNameId)) {
                            resultValues.push({ values, searchFilterType: parts[2] });
                        }
                    }
                }

                if (resultValues.length === 0) {
                    resultValues.push({ values: [] });
                }

                return resultValues;
            };

            // ignore 7 (the max filter type)
            const generatedTemplate = `<search-filters-${scope.currentFilter.TypeId}></search-filters>`; // '<' + scope.filter.FilterId + '-feed-item item="item"></div>';
            element.append($compile(generatedTemplate)(scope));
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productsearch/searchFilters/searchFilterGenerator.directive.js